import { createSelector, createReducer } from '@reduxjs/toolkit';

import {
  getRequestData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { CONTENT_INCLUDE } from '../../constants/api';
import { removeItemFromList, updateDtoList } from '../helpers/reducerHelpers';
import { getIncludedData } from '../helpers/selectorHelpers';
import {
  getAllCommentsForHearingSuccess,
  getAllHearingsSuccess,
  getHearingSuccess,
  getPaginatedCommentsForHearingSuccess,
  getPaginatedHearingsSuccess,
  removeContentsFromStore,
  updateFieldContentSuccess,
} from '../actions/api';
import { getRelId } from '../helpers/apiHelpers';
// -------- Overview --------

// The following endpoints exist
//  - GET /content/{contentId}/download (file-content)
//  - PATCH /hearing/{hearingId}/comment/{commentId}/content (comment-content)
//  - PATCH /hearing/{hearingId}/fieldContent (field-content)
//
// Content is included in the following endpoints
//  - GET /hearing/{hearingId}/comment
//  - GET /hearing
//  - GET /hearing/{hearingId}

// -------- Reducer --------
const contentReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contents = data.filter(
          (include) => include.type === CONTENT_INCLUDE,
        );
        return updateDtoList(state, 'all', contents);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contents = data.filter(
          (include) => include.type === CONTENT_INCLUDE,
        );
        return updateDtoList(state, 'all', contents);
      })
      .addCase(getAllCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contents = data.filter(
          (include) => include.type === CONTENT_INCLUDE,
        );
        return updateDtoList(state, 'all', contents);
      })
      .addCase(getPaginatedCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contents = data.filter(
          (include) => include.type === CONTENT_INCLUDE,
        );
        return updateDtoList(state, 'all', contents);
      })
      .addCase(removeContentsFromStore, (state, action) => {
        const idsToRemove = action.payload;
        return removeItemFromList(state, 'all', idsToRemove);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contents = data.filter(
          (include) => include.type === CONTENT_INCLUDE,
        );
        return updateDtoList(state, 'all', contents);
      })
      .addCase(updateFieldContentSuccess, (state, action) => {
        const contents = getRequestData(action);
        return updateDtoList(state, 'all', contents);
      });
  },
);

// -------- Selectors --------
const selectGetAllcontent = (state) => selectAllFromApiState(state, 'content');
const allContentSelector = createSelector(
  selectGetAllcontent,
  (content) => content,
);

const contentByHearingIdSelector = (hearingId) =>
  createSelector(allContentSelector, (contents) =>
    contents.filter((content) => getRelId(content, 'hearing') === hearingId),
  );

// -------- Exporting --------
export { allContentSelector, contentByHearingIdSelector };
export default contentReducer;
